<template lang="pug">
.progress
  .meter(:style="{ height: `${percent}%` }")
</template>

<script>
export default {
  props: [ 'item', 'max', 'current' ],
  computed: {
    percent () {
      return 100 * this.current / this.max
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.progress {
  display: block;

  position: absolute;
  top: 0;
  left: 0;
  width: 8px;
  bottom: 0;
  background-color: rgba(255, 255, 255, .4);

  line-height: 12px;
  font-size: 12px;

  .meter {
    position: absolute;
    bottom: 0;
    width: 8px;
    background-color: #dc7e47;

  .state {
    line-height: 12px;
    font-size: 12px;
    display: inline-block;


  }
  }
}</style>



// WEBPACK FOOTER //
// src/components/buildings/common/VerticalStorage.vue